/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../../typings/globals/google.maps/index.d.ts" />

module Eseebase {
    export class MapGeometryOverlay {
        public div: HTMLDivElement;
        private overlay: google.maps.OverlayView;
        private canvasElement: HTMLElement;
        private scene: THREE.Scene;
        private sceneElements: any[];
        private renderer: THREE.WebGLRenderer;
        private width: number;
        private height: number;
        private isInitialized: boolean;
        constructor(private position: google.maps.LatLng, private faces: TriangulatedFace[]) {
            var vm = this;
            this.overlay = new google.maps.OverlayView();
            this.width = Math.max(window.innerWidth, window.innerHeight) / 5;
            this.height = 2 * Math.max(window.innerWidth, window.innerHeight) / 15;
            this.overlay.onAdd = function () {
                var map = document.getElementById('map');
                var div = document.createElement('div');
                div.style.borderStyle = 'none';
                div.style.borderWidth = '0px';
                div.style.position = 'absolute';
                div.style.width = vm.width + 'px';
                div.style.height = vm.height + 'px';
                vm.div = div;
                var panes = vm.overlay.getPanes();
                panes.overlayLayer.appendChild(div);
            }

            this.overlay.draw = function () {
                var overlayProjection = vm.overlay.getProjection();
                var posXY = overlayProjection.fromLatLngToDivPixel(vm.position);
                vm.div.style.left = (posXY.x - (vm.width / 2)) + 'px';
                vm.div.style.top = (posXY.y - (2 * vm.height / 3)) + 'px';
                if (!vm.isInitialized) {
                    vm.init();
                    vm.isInitialized = true;
                }
            }

            this.overlay.onRemove = function () {
                vm.unload();
                if (vm.div == null || vm.div.parentElement == null) {
                    return;
                }
                vm.div.parentElement.removeChild(vm.div);
            }
        }

        private init() {
            var vm = this;
            var camera = new THREE.PerspectiveCamera(75, this.width / this.height, 0.1, 10);
            this.scene = new THREE.Scene();
            var angle = 0;

            var colors = ['rgb(255, 50, 50)', 'rgb(30, 250, 80)', 'rgb(0, 50, 120)', 'rgb(125, 125, 50)', 'rgb(200, 150, 100)', 'rgb(100, 255, 0)',
                'rgb(125, 100, 125)', 'rgb(40, 40, 200)', 'rgb(100, 0, 100)', 'rgb(0, 255, 120)', 'rgb(120, 120, 0)', 'rgb(255, 255, 0)',
                'rgb(0, 50, 200)', 'rgb(70, 200, 70)', 'rgb(200, 200, 50)', 'rgb(80, 200, 200)', 'rgb(30, 150, 30)', 'rgb(20, 20, 20)'];
            var levels = [];
            this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
            this.renderer.setClearColor(0x000000, 0);
            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.renderer.setSize(this.width, this.height);
            this.canvasElement = this.renderer.domElement;
            this.div.appendChild(this.renderer.domElement);
            this.sceneElements = [];

            angle = -9 * Math.PI / 20;
            camera.position.x = 0.6 * Math.cos(angle);
            camera.position.y = 0.4;
            camera.position.z = 0.6 * Math.sin(angle);
            camera.lookAt(0, 0, 0);
            camera.updateProjectionMatrix();

            angular.forEach(this.faces, function (face) {
                var geometry = new THREE.Geometry();
                for (var i = 0; i < face.vertices.length; i++) {
                    var v = face.vertices[i];
                    geometry.vertices.push(new THREE.Vector3(v.x, v.z, v.y));

                }

                for (var i = 0; i <= face.indices.length - 3; i += 3) {
                    var idx = face.indices[i] + 1;
                    geometry.faces.push(new THREE.Face3(face.indices[i], face.indices[i + 1], face.indices[i + 2]));

                }

                //var idx = levels.indexOf(face.housingNumber);
                //if (idx == -1) {
                //    levels.push(face.housingNumber);
                //    idx = levels.length - 1;
                //    if (idx > levels.length - 1) {
                //        idx = levels.length - 1;
                //    }
                //}
                var material = new THREE.MeshBasicMaterial({ color: new THREE.Color(/*colors[idx]*/ 'rgb(200, 200, 200)'), side: THREE.DoubleSide }/*{ map: texture }*/);
                var mesh = new THREE.Mesh(geometry, material);
                vm.scene.add(mesh);
                vm.sceneElements.push(mesh);
            });

            camera.aspect = this.width / this.height;
            this.renderer.render(this.scene, camera);
            this.sceneElements.push(camera);
        }

        private unload() {
            for (var elm of this.sceneElements) {
                this.scene.remove(elm);
            }
            this.renderer.forceContextLoss();
        }

        public setMap(map: google.maps.Map) {
            if (this.div != null && map == null) {
                this.div.style.display = 'none';
            }
            this.overlay.setMap(map);
        }
 
    }

}